if (!customElements.get('epk-card-cart-control')) {
  customElements.define(
    'epk-card-cart-control',
    class EpkCardCartControl extends HTMLElement {
      constructor() {
        super();
        this.trigger = this.querySelector('.epk-card-cart-trigger');
        this.panel = this.querySelector('.epk-card-cart-quantity');
        this.input = this.querySelector('.quantity__input');

        if (!this.trigger || !this.panel || !this.input) return;

        this.trigger.addEventListener('click', () => this.toggle());
        this.input.addEventListener('change', () => this.syncState());
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') {
            this.close();
            this.trigger.focus();
          }
        });
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget) && Number(this.input.value) === 0) {
            this.close();
          }
        });

        this.syncState();
      }

      toggle() {
        if (this.classList.contains('is-open')) {
          this.close();
        } else {
          this.open();
        }
      }

      open() {
        this.classList.add('is-open');
        this.trigger.setAttribute('aria-expanded', 'true');
        this.panel.hidden = false;
        this.panel.querySelector('.quantity__button[name="plus"]')?.focus();
      }

      close() {
        this.classList.remove('is-open');
        this.trigger.setAttribute('aria-expanded', 'false');
        this.panel.hidden = true;
      }

      syncState() {
        const hasItems = Number(this.input.value) > 0;
        const isEnglish = document.documentElement.lang.toLowerCase().startsWith('en');
        this.classList.toggle('has-items', hasItems);
        this.trigger.setAttribute(
          'aria-label',
          hasItems
            ? (isEnglish ? 'Change quantity in cart' : 'Menge im Warenkorb ändern')
            : (isEnglish ? 'Add to cart' : 'Zum Warenkorb hinzufügen')
        );
      }
    }
  );
}
